import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNavbarHeight, getViewportDimensions } from '../../../models/Utils';
import {
  setHasVisitedCredo,
  setIsShowingCredoPopup
} from '../../../store/reducers/mainReducer';

import { ADALandmarks, ADAARIARoles } from '../../../models/ADA';

import CreditsWrapper from '../../BuildingBrighterFutures/subcomponents/CreditsWrapper/CreditsWrapper';

import TopSection from '../subcomponents/TopSection/TopSection';
import StoriesSection from '../subcomponents/StoriesSection/StoriesSection';
import VideoSection from '../subcomponents/VideoSection/VideoSection';
import BottomSection from '../subcomponents/BottomSection/BottomSection';

import './CredoMain.scss';

const CredoMain = props => {
  const dispatch = useDispatch();
  const [ heightParams, setHeightParams ] = useState({ marginTop: 0, height: 0 });
  const initialized = useSelector(state => state.data.initialized);
  const cmsData = useSelector(state => state.data.cms.credo);
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const isShowingCredoPopup = useSelector(state => state.data.isShowingCredoPopup);
  let [ada, setADA] = useState("");
  const credoBlocker = useRef(null);

  useEffect(() => {
    document.title = "The Verizon Story - We are Verizon";
    setTimeout(() => {
      dispatch(setHasVisitedCredo(true));
      setADANonRepeating(cmsData.Introduction.AltText);
    }, 100);
  }, []);

  useEffect(() => {

  }, [ada]);

  const handleScroll = () => {
    // if(creditsElement && creditsElement.current){
    //   const sliderRect = creditsElement.current.getBoundingClientRect();
    //   const windowHeight = getViewportDimensions().height;
    //   if ((sliderRect.y <= windowHeight)) {
    //     setCreditsActive(true);
    //   }
    //   else if ((sliderRect.y > windowHeight)) {
    //     setCreditsActive(false);
    //   }
    // }
  };

  const handleResize = () => {
    const marginTop = getNavbarHeight();
    setHeightParams({
      marginTop,
      height: getViewportDimensions().height - marginTop
    });
  };

  const handleStoryDisplay = (isShowingStory) => {
    dispatch(setIsShowingCredoPopup(isShowingStory));
  };

  useLayoutEffect(() => {
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if(!initialized){
    return null;
  }

  function setADANonRepeating(text) {
    if (ada == text) return;
    setADA(text);
  }

  return (
    <div className={`credo-home`} role={ADALandmarks.Main} >
      {/* The div below is a hack for getNavbarHeight() to work */}
      <div className="exhibit-menu-container" style={{ height: 0 }}></div>
      <div style={{ height: `${heightParams.marginTop}px` }}></div>
      {/*<div className="ada-hidden" aria-live="assertive">{ada}</div>*/}
      <TopSection
        introData={cmsData.Introduction}
        sectionHeight={heightParams.height}
        hideFromADA={isShowingCredoPopup}
      />
      <StoriesSection
        general={cmsData.CredoGeneral}
        sections={cmsData.CredoSections}
        storyDisplayCallback={handleStoryDisplay}
      />
      <VideoSection
        data={cmsData.VideoSection}
        sectionHeight={heightParams.height}
        hideFromADA={isShowingCredoPopup}
      />
      <BottomSection
        data={cmsData.FinalSlide}
        sectionHeight={heightParams.height}
        hideFromADA={isShowingCredoPopup}
      />
      <div
        className="credits-el"
        style={{
          visibility: isShowingCredoPopup ? 'hidden' : null
        }}
      >
        <CreditsWrapper 
          next=""
          title=""
          subtitle=""
        />
      </div>
      <div className="credo-blocker" ref={credoBlocker}></div>
    </div>
  );
};

export default CredoMain;